import { render, staticRenderFns } from "./editcard.vue?vue&type=template&id=68eb0d7b&scoped=true"
import script from "./editcard.vue?vue&type=script&lang=js"
export * from "./editcard.vue?vue&type=script&lang=js"
import style0 from "./editcard.vue?vue&type=style&index=0&id=68eb0d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb0d7b",
  null
  
)

export default component.exports